import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { ToastContainer, toast } from 'react-toastify';

import PageContainer from '../../../myComponents/pageContainer';
import PageLoader from '../../../myComponents/loaders/pageLoader';
import { makeURL } from '../../../helperFunctions';
import { getTransformedYourBrandAndConsumersData } from '../../../helperFunctions/getSurveysWithExtractedFields';
import { recentCardExtendedText } from '../../../config/recentCards';

import RecentCardExtended from '../../../myComponents/recentView/recentCardExpanded';
import UserDropdownHeader from '../../../myComponents/userDropdownHeader';
import Watermark from '../../../myComponents/watermark';
import { DEFAULT_BATCH_COUNTRY } from '../../../config/batchConfig';

const useStyles = makeStyles(theme => ({
  mainContainer: {
    width: '95%',
    margin: '30px auto 50px auto',
  },
}));

const BrandConsumersViewAll = () => {
  const classes = useStyles();
  const history = useHistory();
  const appData = useSelector(({ data }) => data);

  const [pageIsLoading, setPageIsLoading] = useState(true);

  useEffect(() => {
    if (!appData.loading) {
      if (appData.error) {
        showToastWarn();
      } else {
        setPageIsLoading(false);
      }
    }
  }, [appData]);

  const showToastWarn = () => {
    toast.warn('Something went wrong, please try again later.', {
      position: 'bottom-right',
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const viewSpecificCustomBatchHandler = brandAndCustomBatchDataId => {
    history.push(makeURL(`/brand-consumers/${brandAndCustomBatchDataId}`));
  };

  const globalStateDataExists = appData.yourBrandAndConsumersData;
  const allCustomBatchCountries = globalStateDataExists ? Object.keys(appData.yourBrandAndConsumersData) : [];
  const batchCountry = allCustomBatchCountries.find(e => e === DEFAULT_BATCH_COUNTRY) ?? allCustomBatchCountries[0];
  const transformedYourBrandAndConsumersData = globalStateDataExists
    ? getTransformedYourBrandAndConsumersData(appData.yourBrandAndConsumersData[batchCountry], batchCountry)
    : [];

  return (
    <Box position="relative" height="100%">
      <UserDropdownHeader bgColor="#f4f4f7" />
      <PageContainer
        headingStyle={{
          fontWeight: 'bold',
          margin: '25px 0 0 25px',
        }}
        style={{
          position: 'relative',
        }}>
        {pageIsLoading ? (
          <PageLoader />
        ) : (
          <Box className={classes.mainContainer}>
            <RecentCardExtended
              heading="Your Brand & Consumers"
              type="brand-consumers"
              listSections={recentCardExtendedText.brandConsumers.listSections}
              surveyData={transformedYourBrandAndConsumersData}
              viewSpecific={viewSpecificCustomBatchHandler}
              isLoading={appData.loading}
            />

            <ToastContainer
              theme="colored"
              position="bottom-right"
              autoClose={4000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Box>
        )}
      </PageContainer>
      <Box position="absolute" bottom="10px" display="flex" justifyContent="center" width="100%">
        <Watermark />
      </Box>
    </Box>
  );
};

export default BrandConsumersViewAll;
